export default function facebookLoginFailure(state) {
  return {
    ...state,
    isFetching: false,
    loggedIn: false,
  };
}